import React, { useEffect, useState } from "react";
import config from "../config";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const ClosingSaleBanner = () => {
  const [products, setProducts] = useState([]);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    const urls = [
      `${config.apiUrl}/productDetail/2400-x-1200-x-100mm-celotex-or-equiv-pir-board-w9Iqn`,
      `${config.apiUrl}/productDetail/class-b-engineering-brick-smooth-red-perforated-400pp-zaceg`,
      `${config.apiUrl}/productDetail/tuscan-multi-red-facing-brick-500pp-MqWGQ`,
      `${config.apiUrl}/productDetail/100mm-solid-concrete-block-7nm2-66pp-FeC4l`,
      `${config.apiUrl}/productDetail/2400-x-1200-x-125mm-sq-edged-plasterboard-vCrzy`,
      `${config.apiUrl}/productDetail/double-pvc-cover-fascia-white-410mm-x-10mm-x-5m-gd1wO`,
      `${config.apiUrl}/productDetail/sl90-cavity-wall-lintel-2100mm-KxsD8`,
    ];

    const manualDiscountPrices = [23.93, 40, 53, 1.29, 6.55, 13.92, 64.46];

    const fetchProducts = async () => {
      try {
        const responses = await Promise.all(
          urls.map((url) => fetch(url).then((res) => res.json())),
        );

        const formattedProducts = responses
          .map((res, index) => {
            let productData = null;

            if (Array.isArray(res?.data)) {
              const product = res.data[0];
              productData = {
                id: product?.id,
                title: product?.name,
                originalPrice: product?.main_price || product?.unit_price,
                image:
                  product?.pics?.[0] ||
                  product?.thumbnail_image ||
                  product?.photos?.[0]?.path ||
                  "",
              };
            }

            if (res?.details) {
              const product = res.details;
              productData = {
                id: product?.id,
                title: product?.name,
                originalPrice: product?.main_price || product?.unit_price,
                image:
                  product?.pics?.[0] ||
                  product?.thumbnail_image ||
                  product?.photos?.[0]?.path ||
                  "",
              };
            }

            if (productData) {
              productData.discountPrice = manualDiscountPrices[index];
            }

            return productData;
          })
          .filter(Boolean);

        setProducts(formattedProducts);
      } catch (error) {
        console.log("API error:", error);
      }
    };

    fetchProducts();
    setTimeout(() => setAnimateIn(true), 100);
  }, []);

  return (
    <section className="closing-sale-section">
      <div className={`sale-banner ${animateIn ? "animate-in" : ""}`}>
        {/* BG decorations */}
        <div className="bg-circle bg-circle-1" />
        <div className="bg-circle bg-circle-2" />
        <div className="diagonal-stripe" />

        {/* Corner badges */}
        <div className="corner-badge corner-tl">
          <span className="badge-text">LIMITED</span>
          <span className="badge-subtext">STOCK</span>
        </div>
        <div className="corner-badge corner-tr">
          <span className="badge-text">FINAL</span>
          <span className="badge-subtext">CLEARANCE</span>
        </div>

        {/* Header */}
        <div className="banner-header">
          <div className="eyebrow-line">
            <span className="eyebrow-dash" />
            <span className="eyebrow-dash" />
          </div>
          <div className="title-stack">
            <h1 className="sale-title">
              <span className="title-word">CLEARANCE</span>
              <i>
                <span className="title-word highlight">SALE</span>
              </i>
            </h1>
            <div className="sale-subtitle">
              <span className="sub-dash">—</span>
              <span className="title-branch">HARROW BRANCH</span>
              <span className="sub-dash">—</span>
            </div>
          </div>
        </div>

        {/* Swiper Slider */}
        <div
          className="swiper-wrapper-outer normal-swiper"
          style={{ height: "200px" }}
        >
          <Swiper
            modules={[Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            loop={true}
            speed={600}
            slidesPerView={2}
            spaceBetween={8}
            breakpoints={{
              480: { slidesPerView: 2, spaceBetween: 8 },
              640: { slidesPerView: 3, spaceBetween: 8 },
              900: { slidesPerView: 4, spaceBetween: 8 },
              1100: { slidesPerView: 5, spaceBetween: 8 },
              1300: { slidesPerView: 6, spaceBetween: 8 },
            }}
            style={{ width: "100%", paddingBottom: "2px" }}
          >
            {products.map((product, i) => {
              const isPFormat = i === 1 || i === 2;

              const originalPriceDisplay = product.originalPrice
                ? `£${Number(product.originalPrice).toFixed(2)}`
                : null;

              const discountPriceDisplay = isPFormat
                ? `${Number(product.discountPrice).toFixed(0)} P`
                : `£${Number(product.discountPrice).toFixed(2)}`;

              return (
                <SwiperSlide key={product.id}>
                  <div className="product-card">
                    <div className="card-badge">SALE</div>

                    <div className="product-image-wrap">
                      <img src={product.image} alt={product.title} />
                    </div>

                    <h5 className="product-title">{product.title}</h5>

                    <div className="price-block">
                      <div className="mainprice">
                        {originalPriceDisplay && (
                          <div className="original-price">
                            {originalPriceDisplay}
                          </div>
                        )}
                        <div className="price-value">
                          {discountPriceDisplay}
                          <sup className="vat-text">+VAT</sup>
                        </div>
                      </div>
                    </div>

                    <div className="card-shine" />
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        {/* Address Footer */}
        <div className="address-footer">
          <span className="map-icon">📍</span>
          <a
            href="https://www.google.com/maps/search/?api=1&query=92-108+Greenford+Road+Harrow+Middlesex+HA1+3QL"
            target="_blank"
            rel="noopener noreferrer"
            className="address-link"
          >
            <span className="address-text">
              92–108 Greenford Road, Harrow, Middlesex, HA1 3QL
            </span>
          </a>
        </div>
      </div>

    <style jsx>{`
  @import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Barlow+Condensed:wght@600;700;800;900&family=Barlow:wght@500;600&display=swap");

  .closing-sale-section {
    background: transparent;
    font-family: "Barlow", sans-serif;
    padding: 0px 20px;
  }

  .sale-banner {
    position: relative;
    background: linear-gradient(
      145deg,
      #0a3d6b 0%,
      #0d4f8a 35%,
      #0f5fa3 65%,
      #0a3d6b 100%
    );
    border-radius: 20px;
    padding: 12px 40px 14px;
    overflow: hidden;
    height: 100%;
    opacity: 0;
    transform: translateY(14px);
    transition: opacity 0.5s ease, transform 0.5s ease;
  }

  .sale-banner.animate-in {
    opacity: 1;
    transform: translateY(0);
  }

  .bg-circle {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
  }
  .bg-circle-1 {
    width: 380px;
    height: 380px;
    background: radial-gradient(
      circle,
      rgba(255, 212, 0, 0.07) 0%,
      transparent 70%
    );
    top: -140px;
    right: -70px;
  }
  .bg-circle-2 {
    width: 220px;
    height: 220px;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.04) 0%,
      transparent 70%
    );
    bottom: -80px;
    left: 5%;
  }
  .diagonal-stripe {
    position: absolute;
    top: 0;
    right: 110px;
    width: 2px;
    height: 100%;
    background: linear-gradient(
      to bottom,
      transparent,
      rgba(255, 212, 0, 0.16),
      transparent
    );
    transform: skewX(-15deg);
  }

  .corner-badge {
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: #ffd400;
    clip-path: polygon(0 0, 100% 0, 100% 78%, 50% 100%, 0 78%);
    z-index: 10;
  }
  .corner-tl {
    left: 22px;
  }
  .corner-tr {
    right: 22px;
  }
  .badge-text {
    font-family: "Barlow Condensed", sans-serif;
    font-size: 10px;
    font-weight: 900;
    color: #0a3d6b;
    line-height: 1;
    letter-spacing: 0.6px;
  }
  .badge-subtext {
    font-family: "Barlow Condensed", sans-serif;
    font-size: 8px;
    font-weight: 700;
    color: #0a3d6b;
  }

  .banner-header {
    text-align: center;
    position: relative;
    z-index: 5;
    margin-bottom: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .title-stack {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .sale-title {
    font-family: "Bebas Neue", sans-serif;
    font-size: 50px;
    font-weight: 900;
    line-height: 0.9;
    letter-spacing: 2px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
  }

  .sale-subtitle {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    margin-top: 4px;
  }

  .sub-dash {
    color: #ffd400;
    font-size: 24px;
    font-weight: 300;
    opacity: 0.6;
  }

  .title-branch {
    color: #fff;
    font-family: "Barlow Condensed", sans-serif;
    font-size: 30px;
    font-weight: 700;
    letter-spacing: 6px;
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.18);
    opacity: 0.95;
    text-transform: uppercase;
  }

  .title-word {
    color: #fff;
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.25);
    font-weight: 900;
  }

  .title-word.highlight {
    color: #ffd400;
    text-shadow: 2px 2px 0 rgba(0, 30, 80, 0.4),
      0 0 30px rgba(255, 212, 0, 0.3);
  }

  /* Swiper outer wrapper */
  .swiper-wrapper-outer {
    position: relative;
    z-index: 5;
    width: 100%;
  }

  /* Product Card */
  .product-card {
    width: 100%;
    min-width: 100%;
    height: 200px !important;
    position: relative;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.13);
    border-radius: 10px;
    padding: 6px 6px 7px;
    text-align: center;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    transition: transform 0.25s ease, background 0.25s ease,
      border-color 0.25s ease, box-shadow 0.25s ease;
  }

  .product-card:hover {
    transform: translateY(-5px) scale(1.02);
    background: rgba(255, 255, 255, 0.14);
    border-color: rgba(255, 212, 0, 0.48);
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28),
      0 0 14px rgba(255, 212, 0, 0.1);
  }

  .card-badge {
    position: absolute;
    top: 5px;
    right: 5px;
    background: #ffd400;
    color: #0a3d6b;
    font-family: "Barlow Condensed", sans-serif;
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 0.8px;
    padding: 2px 5px;
    border-radius: 3px;
    z-index: 2;
  }

  .product-image-wrap {
    background: #fff;
    border-radius: 7px;
    height: 85px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    flex-shrink: 0;
  }
  .product-image-wrap img {
    max-height: 65px;
    max-width: 88%;
    object-fit: contain;
    transition: transform 0.25s ease;
  }
  .product-card:hover .product-image-wrap img {
    transform: scale(1.07);
  }

  .product-title {
    font-family: "Barlow", sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    line-height: 1.35;
    height: 32px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin: 0 0 6px;
    flex-shrink: 0;
  }

  .price-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #132b47;
    border-radius: 8px;
    padding: 8px 6px;
    border: 1px solid rgba(255, 212, 0, 0.25);
  }

  .mainprice {
    display: flex;
    align-items: center;
  }

  .original-price {
    font-family: "Barlow Condensed", sans-serif;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.55);
    text-decoration: line-through;
    margin-bottom: 2px;
    margin-right: 5px;
  }

  .price-value {
    font-family: "Bebas Neue", sans-serif;
    font-size: 26px;
    color: #ffd400;
    letter-spacing: 1px;
    line-height: 1;
    margin-left: 5px;
  }

  .vat-text {
    color: #ffd400;
    font-family: "Bebas Neue", sans-serif;
    font-size: 16px;
    margin-left: 2px;
  }

  .card-shine {
    position: absolute;
    top: 0;
    left: -80%;
    width: 55%;
    height: 100%;
    background: linear-gradient(
      105deg,
      transparent 20%,
      rgba(255, 255, 255, 0.05) 50%,
      transparent 80%
    );
    pointer-events: none;
    transition: left 0.4s ease;
  }
  .product-card:hover .card-shine {
    left: 120%;
  }

  /* Fix swiper slide width so all cards same width/height */
  .swiper-slide {
    height: auto;
    display: flex;
  }
  .swiper-slide > div {
    width: 100%;
    flex-shrink: 0;
  }

  .address-footer {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(255, 212, 0, 0.2);
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    align-items: center;
  }

  .address-link {
    display: flex;
    align-items: center;
    gap: 15px;
    text-decoration: none;
    transition: all 0.3s ease;
    white-space: nowrap;
  }

  .address-text {
    font-family: "Barlow Condensed", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .map-icon {
    font-size: 16px;
    margin-right: 10px;
  }

  .address-link:hover {
    transform: translateY(-2px);
    filter: brightness(1.2);
  }

  /* Responsive */
  @media (max-width: 900px) {
    .sale-banner {
      padding: 16px 28px;
    }
    .sale-title {
      font-size: 34px;
      gap: 8px;
    }
    .title-branch {
      font-size: 24px;
      letter-spacing: 3px;
    }
    .corner-badge {
      width: 50px;
      height: 50px;
    }
  }
  @media (max-width: 600px) {
    .sale-banner {
      padding: 14px 12px;
      border-radius: 14px;
    }
    .sale-title {
      font-size: 26px;
      flex-wrap: wrap;
      gap: 6px;
    }
    .title-branch {
      font-size: 18px;
      letter-spacing: 2px;
    }
    .corner-badge {
      display: none;
    }
    .address-text {
      font-size: 9px;
      letter-spacing: 0.5px;
    }
    .address-footer {
      margin-top: 10px;
    }
  }
`}</style>
    </section>
  );
};

export default ClosingSaleBanner;
